import React from "react";

import MetresField from "../../CoreComponents/MetresField";

function RestaurantAreaField({ value, onChange }) {
  return (
    <MetresField
      id="franchise-restaurant-area"
      label="Restaurants within (metres)"
      hint="How far from the franchise centre a restaurant may be added or moved, e.g. 3000 for 3 km. Leave empty to use the franchise's delivery radius. Each restaurant still delivers its full radius from its own location. Only super admins see this."
      value={value ?? ""}
      onChange={onChange}
    />
  );
}

export default RestaurantAreaField;
